import styled from 'styled-components'

type Props = {
	isVisible: boolean
}

export const HintContainer = styled.div<Props>`
	display: flex;
	height: ${({ isVisible }) => (isVisible ? 'min-content' : 0)};
	visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
	justify-content: space-between;
	align-items: flex-end;
	margin-top: ${({ isVisible }) => (isVisible ? '8px' : 0)};
	color: ${({ theme }) => theme.color.input.textHint};
	flex-shrink: 0;
	font-family: ${({ theme }) => theme.font.family.base};
	font-size: 12px;
`
